import { createStore } from 'satcheljs';
import SharedFolderState from './schema/SharedFolderViewState';

const sharedFolderState: SharedFolderState = {
    showPeoplePickerDialog: false,
};

export const getStore = createStore<SharedFolderState>('sharedFolderState', sharedFolderState);

const store = getStore();

export default store;
